import React from 'react';
import { Helmet } from 'react-helmet-async';
import { landingPageSEO } from '../constants/landingPageData';

interface SEOHeadProps {
  title?: string;
  description?: string;
  keywords?: string[];
  canonicalUrl?: string;
  ogImage?: string;
}

const SEOHead: React.FC<SEOHeadProps> = ({
  title = landingPageSEO.title,
  description = landingPageSEO.description,
  keywords = landingPageSEO.keywords,
  canonicalUrl = landingPageSEO.canonicalUrl,
  ogImage = landingPageSEO.ogImage
}) => {
  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords.join(', ')} />
      <link rel="canonical" href={canonicalUrl} />
      
      {/* Open Graph Meta Tags */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Christ Reigns" />
      
      {/* Twitter Card Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      
      {/* Additional SEO Meta Tags */}
      <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
      <meta name="googlebot" content="index, follow" />
      <meta name="theme-color" content="#4F46E5" />
      <meta name="application-name" content="Christ Reigns" />
      
      {/* Structured Data - Web Application */}
      <script type="application/ld+json">
        {JSON.stringify(landingPageSEO.structuredData)}
      </script>

      {/* Structured Data - Organization */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "Christ Reigns Media",
          "url": "https://christreignslab.com",
          "logo": "https://christreignslab.com/hq-logo.png",
          "sameAs": [
            "https://christreignslab.com"
          ],
          "description": "Christian digital media student led ministry providing Bible study resources and spiritual growth tools",
          "foundingDate": "2023",
          "contactPoint": {
            "@type": "ContactPoint",
            "contactType": "customer service",
            "url": "https://christreignslab.com/contact"
          },
          "makesOffer": {
            "@type": "Offer",
            "itemOffered": {
              "@type": "SoftwareApplication",
              "name": "Christ Reigns Lab", 
              "applicationCategory": "EducationalApplication",
              "operatingSystem": "Web Browser"
            },
            "price": "0",
            "priceCurrency": "USD"
          }
        })}
      </script>
    </Helmet>
  );
};

export default SEOHead;